/// FOURJS_START_COPYRIGHT(D,2017)
/// Property of Four Js*
/// (c) Copyright Four Js 2017, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

/**
 * Helper for server informations
 * @namespace classes.ServerHelper
 */
const ServerHelper = /** @lends classes.ServerHelper */ {
  verRE: /GAS\/([0-9]+)\.([0-9]+)\.([0-9]+)(-([0-9]+))?/,
  /**
   * is version valid
   * @param ver
   * @return {boolean}
   */
  isValid: function (ver) {
    return this.verRE.test(ver);
  },
  /**
   * compare versions
   * @param a
   * @param b
   * @return {number}
   */
  compare: function (a, b) {
    const pa = this.verRE.exec(a) || [];
    const pb = this.verRE.exec(b) || [];
    for (let i = 0; i < 3; i++) {
      const na = Number(pa[i + 1]);
      const nb = Number(pb[i + 1]);
      if (na > nb) {
        return 1;
      }
      if (nb > na) {
        return -1;
      }
      if (!Number.isNaN(na) && Number.isNaN(nb)) {
        return 1;
      }
      if (Number.isNaN(na) && !Number.isNaN(nb)) {
        return -1;
      }
    }
    return 0;
  }
};

modulum("ServerHelper", function (context, cls) {
  cls.ServerHelper = ServerHelper;
});

if (typeof module !== "undefined" && module.exports) {
  module.exports = ServerHelper; // same as    export default ServerHelper;
  module.exports.default = ServerHelper; // same as    export default ServerHelper;
}
